

























import {Component, Mixins, Vue, Prop} from 'vue-property-decorator';
import {Mixin} from "@/mixins";
import store from "@/store";
import PaymentIcons from "@/components/PaymentIcons.vue";

@Component({
    components: {PaymentIcons}
})
export default class SidebarBottom extends Mixins(Mixin) {
    //<editor-fold desc="Private properties">
    store = store();
    //</editor-fold>

    //<editor-fold desc="Props">
    //</editor-fold>

    //<editor-fold desc="Refs">
    //</editor-fold>

    //<editor-fold desc="Watchers">
    //</editor-fold>

    //<editor-fold desc="Getters">
    get showBuyButton() {
        return Array.isArray(this.store.serverData.errors) || Object.keys(this.store.serverData.errors).length === 0
    }
    //</editor-fold>

    //<editor-fold desc="Hooks">
    //</editor-fold>

    //<editor-fold desc="Methods">
    async toCheckout() {
        if (this.store.serverData.personalizedCart && this.store.serverData.personalizedCart.isExpired) {
            return;
        }

        await Promise.all([
            this.store.loadCountries(),
            this.store.syncServer(), // maybe can be omitted
        ]);

        if (
            this.store.serverData.additionalOptions.assembly
            && (!await this.store.checkAssembly())
        ) {
            await this.$nextTick();
                const element = document.querySelector('#ch2-assembly .alert, #ch2-assembly .error');

                if (element) {
                    let top = element.getBoundingClientRect().top
                        + window.scrollY
                        - window.innerHeight / 2
                        + 50;

                    window.scroll({
                        top,
                    });
                }
            return;
        }

        if (this.$route.name !== 'checkout') {
            await this.$router.push({name: 'checkout'});
        }

        window.scrollTo({top: 0});
    }
    //</editor-fold>
}
